import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import wishWall from '../views/wishWall.vue'
import blank from '../views/blank.vue'
import noAuth from '../views/noAuth.vue'
import middleCode from '../views/middleCode.vue'
import luckDraw from '../views/luckDraw.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta:{title:'送出你2025年的第一份祝福！'}
  },
  {
    path: '/blank',
    name: 'blank',
    component: blank,
    meta:{title:'送出你2025年的第一份祝福！'}
  },
  {
    path:'/luckDraw',
    name:luckDraw,
    component: luckDraw,
    meta:{title:'送出你2025年的第一份祝福！'}
  },
  {
    path: '/wish-wall',
    name: 'wishWall',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: wishWall,
    meta:{title:'送出你2025年的第一份祝福！'}
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta:{title:'送出你2025年的第一份祝福！'}
  },
  {
    path: '/no-auth',
    name: 'noAuth',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: noAuth,
    meta:{title:'送出你2025年的第一份祝福！'}
  },
  {
    path: '/middle',
    name: 'middleCode',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: middleCode,
    meta:{title:'语音红包'}
  }
]

const router = new VueRouter({
  routes
})

export default router
